import React, { useEffect, useState, JSX } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { BackstoryPageProps } from '../../components/BackstoryTab';
import { useAppState } from 'hooks/GlobalContext';
import { useAuth } from 'hooks/AuthContext';
import * as Types from 'types/types';
import { SystemInfoComponent } from './SystemInfoPanel';

const Settings = (_props: BackstoryPageProps): JSX.Element => {
  const { apiClient } = useAuth();
  const { setSnack } = useAppState();
  const [systemInfo, setSystemInfo] = useState<Types.SystemInfo | undefined>(undefined);

  useEffect(() => {
    if (systemInfo !== undefined) {
      return;
    }
    const fetchSystemInfo = async (): Promise<void> => {
      try {
        const response: Types.SystemInfo = await apiClient.getSystemInfo();
        setSystemInfo(response);
      } catch (error) {
        console.error('Error obtaining system information:', error);
        setSnack('Unable to obtain system information.', 'error');
      }
    };

    fetchSystemInfo();
  }, [systemInfo, setSnack, apiClient]);

  return (
    <div className="Controls">
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="span">System Information</Typography>
        </AccordionSummary>
        <AccordionDetails>The server is running on the following hardware:</AccordionDetails>
        <AccordionActions>
          <SystemInfoComponent systemInfo={systemInfo} />
        </AccordionActions>
      </Accordion>
    </div>
  );
};

export { Settings };
